/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {firestoreAction} from 'vuexfire';
import {db} from '@/firebaseConfig'

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({commit}, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({commit}, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({commit}, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  addAddressUserInfo({commit}, payload) {
    commit('ADD_ADDRESS_USER_INFO', payload)
  },

  // ////////////////////////////////////////////
  // Cloud FireStore actions
  // ////////////////////////////////////////////

  bindParameters: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('parameters', db.collection('parameters'));
  }),

  bindStores: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('stores', db.collection('catalogs').doc('stores'));
  }),

  bindShowcaseProducts: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('showcaseProducts', db.collection('catalogs').doc('showcase'));
  }),

  bindPriceRanges: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('priceRanges', db.collection('filters').doc('priceRanges'));
  }),

  bindCategories: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('categories', db.collection('catalogs').doc('categories'));
  }),

  bindProductGroups: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('productGroups', db.collection('catalogs').doc('productGroups'));
  }),

  bindProducts: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('products', db.collection('catalogs').doc('products'));
  }),

  bindOrders: firestoreAction(({ bindFirestoreRef }, email) => {
    return bindFirestoreRef('orders', db.collection('orders').where("user", "==", email).orderBy('date', 'desc'));
  }),

  // ////////////////////////////////////////////
  // BAKERY DEPOT COMMON DATA
  // ////////////////////////////////////////////

  updateParameters({commit}, list) {
    commit('UPDATE_PARAMETERS', list);
  },

  updateShowcaseProducts({commit}, list) {
    commit('UPDATE_SHOWCASE_PRODUCTS', list);
  },

  updatePriceRanges({commit}, list) {
    commit('UPDATE_PRICE_RANGES', list);
  },

  updateCategoriesList({commit}, list) {
    commit('UPDATE_CATEGORIES_LIST', list);
  },

  updateCartWarning({commit}, value) {
    commit('UPDATE_CART_WARNING', value);
  },

  updateGiftOrder({commit}, value) {
    commit('UPDATE_GIFT_ORDER', value);
  },

  updateGiftOrderMessage({commit}, value) {
    commit('UPDATE_GIFT_ORDER_MESSAGE', value);
  },

  updateDeliveryType({commit}, value) {
    commit('UPDATE_DELIVERY_TYPE', value);
  },

  updateDeliveryAddress({commit}, value) {
    commit('UPDATE_DELIVERY_ADDRESS', value);
  },

  updateSelectedStore({commit}, value) {
    commit('UPDATE_SELECTED_STORE', value);
  },

  updateHomeScreen({commit}, value) {
    commit('UPDATE_HOME_SCREEN', value);
  },

  updatePriceRange({commit}, item) {
    commit('UPDATE_PRICE_RANGE', item);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateSelectedCategory({commit}, item) {
    commit('UPDATE_SELECTED_CATEGORY', item);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateProductSearch({commit}, phrase) {
    commit('UPDATE_PRODUCT_SEARCH', phrase);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateProductsList({commit}, list) {
    commit('UPDATE_PRODUCTS_LIST', list);
  },

  updateProductImage({commit}, payload) {
    commit('UPDATE_PRODUCTS_IMAGE', payload);
  }

}

export default actions
